var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divPadreDevoluciones" },
    [
      _c(
        "v-flex",
        { attrs: { sm12: "", md12: "", layout: "", wrap: "", "my-2": "" } },
        [
          _c(
            "v-flex",
            { attrs: { sm3: "", md4: "" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  label: "Coordinador",
                  items: _vm.coordinadoresOptions,
                  "item-text": "coorname",
                  "item-value": "coorid",
                  clearable: "",
                  "allow-creation": false
                },
                model: {
                  value: _vm.coordinador,
                  callback: function($$v) {
                    _vm.coordinador = $$v
                  },
                  expression: "coordinador"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md4: "" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  label: "Tipo de Equipo",
                  items: _vm.tipoEquiposOptions,
                  "item-text": "tipoeqname",
                  "item-value": "tipoeqid",
                  clearable: "",
                  "allow-creation": false
                },
                model: {
                  value: _vm.tipoEquipo,
                  callback: function($$v) {
                    _vm.tipoEquipo = $$v
                  },
                  expression: "tipoEquipo"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md4: "" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  label: "Serie Número",
                  items: _vm.numerosSerieOptions,
                  "item-text": "serienumero",
                  "item-value": "serienumero",
                  clearable: "",
                  "allow-creation": false
                },
                model: {
                  value: _vm.serienumero,
                  callback: function($$v) {
                    _vm.serienumero = $$v
                  },
                  expression: "serienumero"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md4: "" } },
            [
              _c("v-combobox", {
                attrs: {
                  label: "Tipo de Fecha",
                  items: [
                    {
                      nombre: "Fecha de Recepción",
                      tipo: 1
                    },
                    {
                      nombre: "Fecha de Registro",
                      tipo: 2
                    }
                  ],
                  "item-text": "nombre",
                  "item-value": "tipo"
                },
                on: { change: _vm.cambiarTipoFecha },
                model: {
                  value: _vm.tipoFecha,
                  callback: function($$v) {
                    _vm.tipoFecha = $$v
                  },
                  expression: "tipoFecha"
                }
              })
            ],
            1
          ),
          _vm.mostrarTipoFechaRecepcion
            ? _c(
                "v-flex",
                { attrs: { sm3: "", md2: "" } },
                [
                  _c("DatePicker", {
                    attrs: {
                      label: "Fecha de Recepción Inicio",
                      max: _vm.fechaMaxima
                    },
                    model: {
                      value: _vm.fechaInicioRecepcion,
                      callback: function($$v) {
                        _vm.fechaInicioRecepcion = $$v
                      },
                      expression: "fechaInicioRecepcion"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.mostrarTipoFechaRecepcion
            ? _c(
                "v-flex",
                { attrs: { sm3: "", md2: "" } },
                [
                  _c("DatePicker", {
                    attrs: {
                      label: "Fecha de Recepción Fin",
                      max: _vm.fechaMaxima
                    },
                    model: {
                      value: _vm.fechaFinRecepcion,
                      callback: function($$v) {
                        _vm.fechaFinRecepcion = $$v
                      },
                      expression: "fechaFinRecepcion"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          !_vm.mostrarTipoFechaRecepcion
            ? _c(
                "v-flex",
                { attrs: { sm3: "", md2: "" } },
                [
                  _c("DatePicker", {
                    attrs: {
                      label: "Fecha de Registro Inicio",
                      max: _vm.fechaMaxima
                    },
                    model: {
                      value: _vm.fechaInicioRegistro,
                      callback: function($$v) {
                        _vm.fechaInicioRegistro = $$v
                      },
                      expression: "fechaInicioRegistro"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          !_vm.mostrarTipoFechaRecepcion
            ? _c(
                "v-flex",
                { attrs: { sm3: "", md2: "" } },
                [
                  _c("DatePicker", {
                    attrs: {
                      label: "Fecha de Registro Fin",
                      max: _vm.fechaMaxima
                    },
                    model: {
                      value: _vm.fechaFinRegistro,
                      callback: function($$v) {
                        _vm.fechaFinRegistro = $$v
                      },
                      expression: "fechaFinRegistro"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c("v-flex", { attrs: { sm3: "", md4: "" } }, [
            _c(
              "div",
              { staticClass: "text-sm-center" },
              [
                _c(
                  "v-btn",
                  { on: { click: _vm.handleBuscar } },
                  [_c("v-icon", [_vm._v("search")]), _vm._v("Filtrar ")],
                  1
                ),
                _c(
                  "v-btn",
                  { on: { click: _vm.clearFilters } },
                  [_c("v-icon", [_vm._v("clear")]), _vm._v("Limpiar ")],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "div",
        { staticClass: "divDevoluciones" },
        [
          _c(
            "v-flex",
            { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", sm6: "", md6: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm8: "", md8: "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Buscar...",
                          clearable: "",
                          outlined: ""
                        },
                        on: {
                          keyup: function($event) {
                            return _vm.gridApi.setQuickFilter(_vm.filtro)
                          },
                          "click:clear": function($event) {
                            return _vm.gridApi.setQuickFilter("")
                          }
                        },
                        model: {
                          value: _vm.filtro,
                          callback: function($$v) {
                            _vm.filtro = $$v
                          },
                          expression: "filtro"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-flex",
                {
                  attrs: {
                    xs12: "",
                    sm6: "",
                    md6: "",
                    layout: "",
                    "mt-0": "",
                    "justify-end": "",
                    "align-center": ""
                  }
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "", small: "", color: "primary" },
                      on: { click: _vm.getCSV }
                    },
                    [
                      _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                        _vm._v("cloud_download")
                      ]),
                      _vm._v("\n            \n          "),
                      _c("span", { staticClass: "importExportBtnTexto" }, [
                        _vm._v("Exportar"),
                        _c("br"),
                        _vm._v("CSV")
                      ])
                    ],
                    1
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "btnCrear mr-0 ml-2",
                      on: {
                        click: function($event) {
                          _vm.abrirModalCrear = true
                        }
                      }
                    },
                    [
                      _c("v-icon", { attrs: { dark: "", left: "" } }, [
                        _vm._v("add_circle_outline")
                      ]),
                      _c("span", [_vm._v("Crear")])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "ModalMantenedor",
                { attrs: { show: _vm.abrirModalCrear } },
                [
                  _c(
                    "CabeceraModalDevolucionCrear",
                    {
                      attrs: {
                        permitirGuard: _vm.permitirGuardCrear,
                        mostrarBtnContinuarCrear: _vm.mostrarBtnContinuarCrear
                      },
                      on: {
                        cerrarCrear: _vm.cerrarModalCrear,
                        guardarCrear: _vm.handleGuardar
                      }
                    },
                    [
                      _c("NavegacionModalCrud", {
                        attrs: {
                          pasos: _vm.pasosCrear,
                          "estado-id": _vm.estadoIdCrear
                        },
                        on: { guardar: _vm.handleGuardar },
                        model: {
                          value: _vm.pasoActivoIndexCrear,
                          callback: function($$v) {
                            _vm.pasoActivoIndexCrear = $$v
                          },
                          expression: "pasoActivoIndexCrear"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-stepper",
                    {
                      model: {
                        value: _vm.pasoActivoIndexCrear,
                        callback: function($$v) {
                          _vm.pasoActivoIndexCrear = $$v
                        },
                        expression: "pasoActivoIndexCrear"
                      }
                    },
                    [
                      _c("CrudStepperHeader", {
                        attrs: {
                          pasos: _vm.pasosCrear,
                          "paso-activo-index": _vm.pasoActivoIndexCrear
                        }
                      }),
                      _c(
                        "CrudStepperItems",
                        [
                          _c(
                            "CrudStepperContent",
                            { attrs: { paso: _vm.pasosCrear.devolucion } },
                            [
                              _c("ComponenteForm", {
                                attrs: {
                                  listaTipoEquipos: _vm.tipoEquiposOptions,
                                  listaCoordinadores: _vm.coordinadoresOptions,
                                  creacion: true
                                },
                                on: {
                                  objCreacion: _vm.objsParaAlta,
                                  ocultarGuardar: _vm.ocultarGuardar
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "CrudStepperContent",
                            { attrs: { paso: _vm.pasosCrear.crearReporte } },
                            [
                              _vm.mostrarRepoTecnicos
                                ? _c("ComponenteDialogoReporteTecnico", {
                                    attrs: {
                                      num: _vm.devoNumeRTcr,
                                      mostrarBtnCrear: true,
                                      accion: "crear"
                                    },
                                    on: { objReporte: _vm.objsParaAlta }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "ModalMantenedor",
                { attrs: { show: _vm.abrirModalEditar } },
                [
                  _c(
                    "CabeceraModalDevolucionEditar",
                    {
                      attrs: {
                        mostrarBtnVolver: _vm.mostrarVolverEditar,
                        permitirContinuarEditar: _vm.permitirContinuarEditar,
                        mostrarBtnContinuarEditar: _vm.mostrarBtnContinuarEditar
                      },
                      on: {
                        cerrarEditar: _vm.cerrarModalEditar,
                        continuarEditar: _vm.continuarEditar,
                        volverEditar: _vm.volverEditar
                      }
                    },
                    [
                      _c("NavegacionModalCrud", {
                        attrs: {
                          pasos: _vm.pasosEditar,
                          "estado-id": _vm.estadoIdEditar
                        },
                        on: { continuar: _vm.continuarEditar },
                        model: {
                          value: _vm.pasoActivoIndexEditar,
                          callback: function($$v) {
                            _vm.pasoActivoIndexEditar = $$v
                          },
                          expression: "pasoActivoIndexEditar"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-stepper",
                    {
                      model: {
                        value: _vm.pasoActivoIndexEditar,
                        callback: function($$v) {
                          _vm.pasoActivoIndexEditar = $$v
                        },
                        expression: "pasoActivoIndexEditar"
                      }
                    },
                    [
                      _c("CrudStepperHeader", {
                        attrs: {
                          pasos: _vm.pasosEditar,
                          "paso-activo-index": _vm.pasoActivoIndexEditar
                        }
                      }),
                      _c(
                        "CrudStepperItems",
                        [
                          _c(
                            "CrudStepperContent",
                            {
                              attrs: { paso: _vm.pasosEditar.editarDevolucion }
                            },
                            [
                              _c("ComponenteForm", {
                                ref: "formulario",
                                attrs: {
                                  listaTipoEquipos: _vm.tipoEquiposOptions,
                                  listaCoordinadores: _vm.coordinadoresOptions,
                                  edicion: true,
                                  data: _vm.infoEdicion
                                },
                                on: { objEdit: _vm.objEditCabecera }
                              })
                            ],
                            1
                          ),
                          _c(
                            "CrudStepperContent",
                            { attrs: { paso: _vm.pasosEditar.crearReporte } },
                            [
                              _c("ComponenteDialogoReporteTecnico", {
                                attrs: {
                                  num: _vm.devoNumeRTed,
                                  mostrarBtnCrear: true,
                                  accion: "editar",
                                  anulado: _vm.infoEdicion[0]
                                },
                                on: { objReporte: _vm.objsParaAlta }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "ModalMantenedor",
            { attrs: { show: _vm.abrirModalVer } },
            [
              _c(
                "CabeceraModalDevolucionVista",
                {
                  attrs: {
                    mostrarBtnContinuar: _vm.mostrarContinuarVer,
                    mostrarBtnVolver: _vm.mostrarVolverVer
                  },
                  on: {
                    cerrarVer: _vm.cerrarModalVer,
                    continuarVer: _vm.continuarVer,
                    volverVer: _vm.volverVer
                  }
                },
                [
                  _c("NavegacionModalCrud", {
                    attrs: {
                      pasos: _vm.pasosVer,
                      "estado-id": _vm.estadoIdVer
                    },
                    model: {
                      value: _vm.pasoActivoIndexVer,
                      callback: function($$v) {
                        _vm.pasoActivoIndexVer = $$v
                      },
                      expression: "pasoActivoIndexVer"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-stepper",
                {
                  model: {
                    value: _vm.pasoActivoIndexVer,
                    callback: function($$v) {
                      _vm.pasoActivoIndexVer = $$v
                    },
                    expression: "pasoActivoIndexVer"
                  }
                },
                [
                  _c("CrudStepperHeader", {
                    attrs: {
                      pasos: _vm.pasosVer,
                      "paso-activo-index": _vm.pasoActivoIndexVer
                    }
                  }),
                  _c(
                    "CrudStepperItems",
                    [
                      _c(
                        "CrudStepperContent",
                        { attrs: { paso: _vm.pasosVer.verDevolucion } },
                        [
                          _c("ComponenteForm", {
                            attrs: {
                              listaTipoEquipos: _vm.tipoEquiposOptions,
                              listaCoordinadores: _vm.coordinadoresOptions,
                              visualizacion: true,
                              data: _vm.infoVisualizacion
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "CrudStepperContent",
                        { attrs: { paso: _vm.pasosVer.verReporte } },
                        [
                          _c("ComponenteDialogoReporteTecnico", {
                            attrs: {
                              num: _vm.devoNumeRTver,
                              mostrarBtnCrear: false,
                              accion: "ver"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "gridcard rounded-card" },
        [
          _c("MantenedorGridSinCodigo", {
            attrs: {
              "grid-options": _vm.gridOptions,
              funcionalidadId: _vm.funcionalidad,
              id: "tabla"
            }
          })
        ],
        1
      ),
      _vm.showPopUpReport
        ? _c("PopUpGeneratedReports", {
            attrs: { text: _vm.msgReport },
            on: { cerrar: _vm.handleCloseReport }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }